<template>
  <v-data-table
    :headers="headers"
    :items="orderItems"
    :total-items="totalOrderItems"
    :pagination.sync="pagination"
    :loading="loading"
    class="elevation-1"
    :style="{'margin-bottom': '10px'}"
    :must-sort="true"
    :rows-per-page-items="[10, 20, 50]"
    :rows-per-page-text="'Rows per page'"
  >
    <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>

    <template slot="headers" slot-scope="{}">
      <tr>
        <th v-for="header in headers"
            class="column"
            :class="sortingClasses(header)"
            :key="header.value"
            :style="{ 'min-width': header.width ? `${header.width}px` : '0' }"
            @click="updateSorting(header)">
          <span v-show="'right' !== header.align">{{ header.text }}</span>
          <v-icon v-if="header.sortable === undefined || header.sortable" :small="true">
            {{ $vuetify.icons.sort }}
          </v-icon>
          <span v-show="'right' === header.align">{{ header.text }}</span>
        </th>
      </tr>
    </template>

    <template slot="items" slot-scope="props">
      <tr class="data-table__row">
        <td class="text-xs-left">{{ props.item.label }}</td>
        <td class="text-xs-left">{{ props.item.amount }}</td>
        <td class="text-xs-left">{{ props.item.taxRate }}</td>
        <td class="text-xs-left">{{ props.item.currency }}</td>
        <td class="text-xs-left">{{ props.item.count }}</td>
        <td class="text-xs-left">{{ props.item.unit }}</td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
import axios from 'axios';
import queries from '../../utils/queries';

export default {
  name: 'MPayMerchantOrderItemsTable',

  props: {
    orderId: {
      type: String,
      required: true,
    },
  },

  data: () => ({
    orderItems: [],
    totalOrderItems: 0,

    headers: [
      { text: 'Label', value: 'label' },
      { text: 'Amount', value: 'amount' },
      { text: 'Tax Rate', value: 'taxRate' },
      { text: 'Currency', value: 'currency' },
      { text: 'Count', value: 'count' },
      { text: 'Unit', value: 'unit' },
    ],
    pagination: {
      sortBy: 'label',
      descending: true,
    },
    filtering: {},
    serverReturnedNothing: false,

    loading: false,
  }),

  methods: {
    getOrderItems() {
      this.orderItems = [];
      this.serverReturnedNothing = false;
      this.clearMessages();
      this.loading = true;

      axios.get(queries.merchantOrderItems(this.orderId))
        .then((response) => {
          this.orderItems = response.data.content || [];
          this.totalOrderItems = response.data.totalElements;
          this.serverReturnedNothing = this.orderItems.length === 0;
          this.loading = false;
        })
        .catch((e) => {
          this.showError(e);
          this.loading = false;
        });
    },
    resetPagination() {
      this.pagination.page = 1;
    },
    /* eslint-disable no-param-reassign */
    updateFiltering(property, event) {
      const value = event.target.value.trim();
      event.target.value = value;
      this.resetPagination();
      this.filtering[property] = value;
      this.getUsers();
    },
    updateSorting(header) {
      if (header.sortable !== undefined && !header.sortable) {
        return;
      }
      if (this.pagination.sortBy === header.value) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = header.value;
        this.pagination.descending = false;
      }
    },
    sortingClasses(header) {
      const classes = [];
      if (header.sortable !== false) {
        classes.push('sortable');
      }
      if (header.align) {
        classes.push(`text-xs-${header.align}`);
      } else {
        classes.push('text-xs-left');
      }
      const beingSorted = this.pagination.sortBy === header.value;
      if (beingSorted) {
        classes.push('active');
        if (this.pagination.descending) {
          classes.push('desc');
        } else {
          classes.push('asc');
        }
      }
      if (header.text === '') {
        classes.push('px-0');
      }
      return classes;
    },
  },

  watch: {
    pagination: {
      handler() {
        this.getOrderItems();
      },
      deep: true,
    },
  },

  created() {
    this.getOrderItems();
  },

};
</script>




// WEBPACK FOOTER //
// src/components/merchant/MPayMerchantOrderItemsTable.vue